import React from 'react';

import { Alert } from 'reactstrap';

const LeadNotAssociatedWithTheAgent = props => {
  const messages = props.message.map((item, index) => (
    <p key={index}>
      <strong>{item}</strong>
    </p>
  ));

  return (
    <Alert color='warning' className='mt-2 mb-2'>
      {messages}
      <a href={props.link}>{props.link}</a>
    </Alert>
  );
};

export default LeadNotAssociatedWithTheAgent;
